import { render } from "./QuickChanges.vue?vue&type=template&id=280b87a8&scoped=true"
import script from "./QuickChanges.vue?vue&type=script&lang=js"
export * from "./QuickChanges.vue?vue&type=script&lang=js"

import "./QuickChanges.vue?vue&type=style&index=0&id=280b87a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280b87a8"]])

export default __exports__